import React from "react";
import { Box, Container } from '@mui/material';
import Grid from '@mui/system/Grid';
import "../../style/pages/_studentDashboard.scss"

const AdminPanelHeader = () => {
  return (
    <Container maxWidth="lg" className="parentdiv registerusers" sx={{marginBottom:"40px"}}>
        <Box>
        <Grid>
          <Grid item xs={12} md={12} className="heading" sx={{textAlign:"center"}}>
          <h1>Admin Dashboard</h1>
          <p className='student-info'>Stay updated with your learning progress, access study materials, and manage your profile—all in one place. Keep learning and growing!</p>
          </Grid>
          </Grid>
          </Box>
          </Container>
  )
}

export default AdminPanelHeader
